import { TmFormControl } from './tm-form-control';
import { FORM_CONTROL_CLASS_NAME } from './tm-form-control.types';

/**
 * Given an element, get all `TmFormControl` instances contained within it (including the element itself).
 */
export function getFormControls(e: Element) {
    const controls = e.querySelectorAll(`.${FORM_CONTROL_CLASS_NAME}`);

    return ([e, ...controls] as Element[]).filter(
        e => e instanceof TmFormControl
    ) as TmFormControl<unknown>[];
}
